<template>
  <div class="settle_month_page">
    <div class="page-title">月账单</div>
    <div class="page_search">
      <DatePicker
        v-model="searchDate"
        ref="searchInput"
        :type="searchDateType"
        :editable="false"
        :clearable="false"
        placeholder="请选择"
        style="width: 156px"
        :options="monthOpts"
      ></DatePicker>
      <span class="search_btn" @click="searchFn" >查询</span>
    </div>

    <div class="export_line">
      <div class="export_btn" @click="downloadFn" :class="{'export_btn_not': !downFlag}">
        <i class="yjh-icon icon-export"></i>
        <span>导出</span>
      </div>
    </div>
    <div class="down_target" v-loading="tableLoading">
    <div class="table_wrapper">
      <table class="target_table">
        <thead>
          <tr>
            <td colspan="4">{{monthTableInfo.title || ''}}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>结算单编号:</td><td>{{monthTableInfo.final_statement || ''}}</td><td>结算周期:</td><td>{{monthTableInfo.statement_interval || ''}}</td>
          </tr>
          <tr>
            <td class="td_weight">工具名称</td><td class="td_weight">数量(次)</td><td class="td_weight">底价(元)</td><td class="td_weight">合计金额(元)</td>
          </tr>
          <template v-if="monthTableInfo.tool_list && monthTableInfo.tool_list.length">
          <tr v-for="(item, index) in monthTableInfo.tool_list" :key="index">
            <td>{{item.tool_name_text}}</td>
            <td>{{item.count_num}}</td>
            <td style="text-align: right; padding-right: 10px;">{{item.tool_money | toF}}</td>
            <td style="text-align: right; padding-right: 10px;">{{item.tool_money_sum | toF}}</td>
          </tr>
          </template>
          <!-- <template v-else>
            <tr v-for="(item, index) in 3" :key="index">
              <td>{{['初级工具包', '中级工具包', '高级工具包'][index]}}</td>
              <td></td>
              <td style="text-align: right; padding-right: 10px;"></td>
              <td style="text-align: right; padding-right: 10px;"></td>
            </tr>
          </template> -->
          <!-- <tr>
            <td>中级工具包</td><td>数量(次)</td><td>底价(元)</td><td>合计金额(元)</td>
          </tr>
          <tr>
            <td>高级工具包</td><td>数量(次)</td><td>底价(元)</td><td>合计金额(元)</td>
          </tr> -->
          <tr>
            <td class="td_weight td_60">费用总计（元）</td><td class="td_60">{{AmountLtoU(monthTableInfo.tool_money_sum_all)}}</td><td class="td_weight td_60" style="text-align: right; padding-right: 20px;">小写:</td>
            <td class="td_60" style="text-align: right; padding-right: 10px;">{{monthTableInfo.tool_money_sum_all | toF}}</td>
          </tr>
          <tr>
            <td class="td_weight td_right td_60">甲方公司:</td><td class="td_60">{{monthTableInfo.first_party}}</td><td class="td_weight td_right td_60">乙方公司:</td><td class="td_60">{{monthTableInfo.second_party}}</td>
          </tr>
          <tr>
            <td class="td_right td_180">盖章:</td><td class="td_180"></td><td class="td_right td_180">盖章:</td><td class="td_180"></td>
          </tr>
          <tr>
            <td class="td_right td_40">日期:</td>
            <td class="td_40">年<span style="padding: 0 30px;">月</span>日</td>
            <td class="td_right td_40">日期:</td>
            <td class="td_40">年<span style="padding: 0 30px;">月</span>日</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table_new">
      <div class="month_title">交易明细 ({{total}})</div>
      <table class="page_table_fake">
        <thead>
          <tr>
            <th style="width: 16%;">使用时间</th>
            <th style="width: 8%;">状态</th>
            <th style="width: 12%;">企业编码</th>
            <th style="width: 8%;">类型</th>
            <th style="width: 12%;">企业名称</th>
            <th style="width: 8%;">工具名称</th>
            <th style="width: 8%;">时间</th>
            <th style="width: 14%;">卡号</th>
            <th style="width: 14%;">卡密</th>
          </tr>
        </thead>
        <tbody v-if="tableData.length">
          <tr v-for="(infoItem, infoIndex) in tableData" :key="infoIndex">
            <td :title="infoItem.use_time">{{infoItem.use_time}}</td>
            <td :title="infoItem.is_use_text" :class="{'gre': infoItem.is_use_text === '已使用'}">{{infoItem.is_use_text}}</td>
            <td :title="infoItem.cust_no">{{infoItem.cust_no}}</td>
            <td :title="infoItem.company_type">{{infoItem.company_type}}</td>
            <td :title="infoItem.cust_name">{{infoItem.cust_name}}</td>
            <td :title="infoItem.tool_name_text">{{infoItem.tool_name_text}}</td>
            <td :title="infoItem.tool_time_length">{{infoItem.tool_time_length}}</td>
            <td :title="infoItem.card_no_confound">{{infoItem.card_no_confound}}</td>
            <td :title="infoItem.card_pwd_confound">{{infoItem.card_pwd_confound}}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="!tableData.length" class="no_fake_data">
        暂无数据
      </div>
      <pageTable
        :loading="tableLoading"
        :col="col"
        :data="tableData"
        :showPage="false"
        :isVerticalResize="false"
        style="display: none;"
      ></pageTable>
    </div>
    </div>
  </div>
</template>
<script>
import { dateObjToStr } from '@/utils/common'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import { downloadPdf } from '@/utils/file.js'
import { getMonthBill, getBillInfo } from '@/api/newagent.js'
export default {
  name: 'settlemonth',
  components: { pageTable },
  mixins: [pageTableMixin],
  filters: {
    toF(value) {
      if (value === '' || value === undefined || value === null) {
        return ''
      } else {
        return Number(value).toFixed(2)
      }
    }
  },
  data() {
    return {
      searchDate: '',
      searchDateType: 'month',
      monthOpts: {
        disabledDate(date) {
          var now = new Date()
          // return date.getFullYear() < 2018 || date.getFullYear() > now.getFullYear() || (date.getFullYear() === now.getFullYear() && date.getMonth() > now.getMonth())
          return date.getFullYear() < 2018 || date.getFullYear() > now.getFullYear() || (date.getFullYear() === now.getFullYear() && date.getMonth() > now.getMonth() - 1)
        }
      },
      col: [
        { field: 'use_time', title: '使用时间', width: 120, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'is_use_text', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true,
          formatter(rowData, pIndex, index, field) {
            if (rowData[field] === '已使用') {
              return '<span style="color:#2BB968;">已使用</span>'
            } else {
              return rowData[field]
            }
          }
        },
        { field: 'cust_no', title: '企业编码', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'company_type', title: '类型', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'cust_name', title: '企业名称', width: 120, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'tool_name_text', title: '工具名称', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'tool_time_length', title: '时间', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'card_no_confound', title: '卡号', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'card_pwd_confound', title: '卡密 ', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true }
      ],
      demo: '',
      monthTableInfo: {},
      total: 0,
      downFlag: false
    }
  },
  mounted() {
    document.querySelector('.normal-right-inner-wrap').addEventListener('scroll', this.slidSearch)
  },
  methods: {
    slidSearch() {
      this.$refs.searchInput.visible = false
    },
    initPage() {
      // this.searchDate = new Date()
      this.searchDate = new Date(new Date().setMonth(new Date().getMonth() - 1))
    },
    getData() {
      this.tableLoading = true
      const fullDate = dateObjToStr(this.searchDate).replace(/\-/g, '').split(' ')[0].substring(0, 6)
      this.downFlag = false
      getMonthBill({
        month_date: fullDate.substring(0, 4) + '-' + fullDate.substring(4, 6)
      }).then(res => {
        if (res.code === 0) {
          this.monthTableInfo = res.result
        }
        this.downFlag = true
      })
      document.querySelector('.normal-right-inner-wrap').style.overflow = 'hidden'
      getBillInfo({
        month_date: fullDate.substring(0, 4) + '-' + fullDate.substring(4, 6)
      }).then(res => {
        document.querySelector('.normal-right-inner-wrap').style.overflow = 'auto'
        if (res.code === 0) {
          this.tableData = res.result
          this.total = res.result.length
        } else {
          this.tableData = []
          this.total = 0
        }
        this.tableLoading = false
      })
    },
    searchFn() {
      this.pageSize = 30
      this.page = 1
      this.getData()
    },
    AmountLtoU(num) {
      if (isNaN(num)) return ''
      var strPrefix = ''
      if (num < 0) strPrefix = '(负)'
      num = Math.abs(num)
      if (num >= 1000000000000) return '无效数值'
      var strOutput = ''
      var strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分'
      var strCapDgt = '零壹贰叁肆伍陆柒捌玖'
      num += '00'
      var intPos = num.indexOf('.')
      if (intPos >= 0) {
        num = num.substring(0, intPos) + num.substr(intPos + 1, 2)
      }
      strUnit = strUnit.substr(strUnit.length - num.length)
      for (var i = 0; i < num.length; i++) {
        strOutput += strCapDgt.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1)
      }
      return strPrefix + strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, '零元')
    },
    downloadFn() {
      if (!this.downFlag) {
        return
      }
      downloadPdf(document.querySelector('.down_target'), this.monthTableInfo.title || '名字')
    }
  },
  beforeDestroy() {
    document.querySelector('.normal-right-inner-wrap').removeEventListener('scroll', this.slidSearch)
  }
}
</script>
<style lang="scss" scoped>
.search_btn {
  margin-left: 20px;
  width: 58px;
  height: 28px;
  line-height: 28px;
  border-radius: 2px;
  // opacity: .8;
  font-size: 12px;
  background-color: #1881dc;
  border-color: #1881dc;
  -webkit-transition: all .2s;
  transition: all .2s;
  color: #FFF;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}
.export_line {
  height: 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .export_btn {
    cursor: pointer;
  }
  .export_btn_not {
    cursor: not-allowed;
    opacity: .7;
  }
}
.table_wrapper {
  padding: 20px 10px 30px 10px;
  width: 100%;
}
.target_table {
  width: 100%;
  border-collapse:collapse;
  border: 1px solid #DAE3EA;
  thead {
    td  {
      line-height: 40px;
      text-align: center;
      font-weight: 600;
      width: 100%;
      font-size: 18px;
      border-bottom: 1px solid #DAE3EA;
    }
  }
  tbody {
    tr {
      td {
        line-height: 32px;
        height: 32px;
        text-align: center;
        border: 1px solid #DAE3EA;
      }
      .td_weight {
        font-weight: 700;
      }
      .td_right {
        text-align: right;
        padding-right: 20px;
      }
      .td_40 {
        line-height: 40px;
      }
      .td_60 {
        line-height: 60px;
      }
      .td_180 {
        line-height: 180px;
      }
    }
  }
}
.table_new {
  width: 100%;
  padding: 0 10px;
  .month_title {
    padding-bottom: 20px;
    font-size: 14px;
  }
}
.page_table_fake {
  width: 100%;
  min-width: 740px;
  border-collapse: collapse;
  border: 1px solid #D9E2EF;
  thead {
    background: #F3F6F8;
    border-bottom: 1px solid #D9E2EF;
    border-left: 1px solid #D9E2EF;
    border-top: 1px solid #D9E2EF;
    th {
      height: 50px;
      line-height: 50px;
      text-align: left;
      padding: 0 10px;
      font-weight: normal;
      font-size: 12px;
    }
  }
  tbody {
    tr {
      background: #FFFFFF;
      border-left: 1px solid #D9E2EF;
      &:nth-child(2n) {
        background: #F3F6F8;
      }
      td {
        line-height: 32px;
        height: 32px;
        padding: 0 10px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .gre {
        color: #2BB968;
      }
    }
  }
}
.no_fake_data {
  width: 100%;
  height: 300px;
  text-align: center;
  font-size: 12px;
  color: #B5C2D0;
  padding-top: 90px;
}
</style>

